export default {
  name: 'lsIndex',
  data() {
    return {
      singleform: {
        fid: '151066',
        formId: '112712',
        limit: 50
      }
    };
  },
  mounted() {
    this.getsingleformList();
  },
  methods: {
    getsingleformList() {
      this.$api.singleformList(this.singleform).then(res => {
        console.log(res);
      });
    }
  }
};